import config from "../config";
import { PlateAddress } from "../Model/PlateAddress";
import {
  concatOptionalParameter,
  sendGetRequest,
  sendPostRequest,
} from "./../Utility/FetchUtils";
import { StorageConfig } from "../Model/StorageConfig";

class StorageApi {
  static BASE_URL = config.SERVICE_URL + "/storage";

  static getPlateAddresses(moduleIdentifier?: string) {
    let url = StorageApi.BASE_URL + "/plate-addresses";
    url = concatOptionalParameter(url, {
      "module-identifier": moduleIdentifier,
    });
    return sendGetRequest<PlateAddress[]>(url);
  }

  static getStorageConfigs() {
    let url = StorageApi.BASE_URL + "/storage-configs";
    return sendGetRequest<StorageConfig[]>(url);
  }

  static scanSlot(
    moduleIdentifier: string,
    hotelIdentifier: number,
    slotIdentifier: number
  ) {
    const url =
      this.BASE_URL +
      "/scan/" +
      moduleIdentifier +
      "/" +
      hotelIdentifier +
      "/" +
      slotIdentifier;
    return sendPostRequest(url);
  }

  static scanHotel(moduleIdentifier: string, hotelIdentifier: number) {
    const url =
      this.BASE_URL + "/scan/" + moduleIdentifier + "/" + hotelIdentifier;
    return sendPostRequest(url);
  }

  static scanModule(moduleIdentifier: string) {
    const url = this.BASE_URL + "/scan/" + moduleIdentifier;
    return sendPostRequest(url);
  }

  static handScan(
    moduleIdentifier: string,
    hotelIdentifier: number,
    slotIdentifier: number,
    barcode: string
  ) {
    const url =
      this.BASE_URL +
      "/hand-scan/" +
      moduleIdentifier +
      "/" +
      hotelIdentifier +
      "/" +
      slotIdentifier +
      "/" +
      encodeURIComponent(barcode);
    return sendPostRequest(url);
  }

  static clearPlateRegistration(
    moduleIdentifier: string,
    hotelNo: number,
    slotNo: number
  ) {
    const url = `${this.BASE_URL}/clear-plate-registration/${moduleIdentifier}/${hotelNo}/${slotNo}`;
    return sendPostRequest(url);
  }
}

export default StorageApi;
